import React from 'react';
import { useWatch } from 'react-hook-form';
import PropTypes from 'prop-types';
import TextFieldHookForm from 'components/Common/InputBox/TextFieldHookForm';
import {
  validDigit,
  validLength,
  validPersonalInfo,
  validRepeat,
  validSpecialChar,
} from 'components/IncorporationOfTerms/IncorporationOfTermsSchema';
import TblRow from 'components/IncorporationOfTerms/Register/FormAtoms/TblRow';
import TblRowTail from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowTail';
import TblRowHeader from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowHeader';
import PasswordCheckRow from 'components/IncorporationOfTerms/Register/FormAtoms/PasswordCheckRow';

export const PasswordInput = ({ disabled, pwdName, label, isGuide, placeholderLabel }) => {
  const [userId, mphonNo, pwd] = useWatch({
    name: ['userId', 'mphonNo', 'pwd'],
  });
  return (
    <>
      <TblRow>
        <TblRowHeader rowHeader={label} isRequired />
        <TblRowTail>
          <TextFieldHookForm
            name={pwdName} // pwd
            className="type-full"
            maxLength={12}
            componentType="inputPassword"
            disabled={disabled}
            placeholderLabel={placeholderLabel}
            useExpLabel={!isGuide}
          />
          {isGuide && (
            <div className="check-list-wrap">
              <ul className="check-list">
                <PasswordCheckRow messsage="MB_T_PASSWORD_RULE1" validation={validLength(pwd)} />
                <PasswordCheckRow messsage="MB_T_PASSWORD_RULE2" validation={validSpecialChar(pwd)} />
                <PasswordCheckRow messsage="MB_T_PASSWORD_RULE3" validation={validRepeat(pwd)} />
                <PasswordCheckRow messsage="MB_T_PASSWORD_RULE4" validation={validDigit(pwd)} />
                <PasswordCheckRow messsage="MB_T_PASSWORD_RULE5" validation={validPersonalInfo(pwd, userId, mphonNo)} />
              </ul>
            </div>
          )}
        </TblRowTail>
      </TblRow>
    </>
  );
};
PasswordInput.propTypes = {
  disabled: PropTypes.bool,
  pwdName: PropTypes.string,
  label: PropTypes.string,
  isGuide: PropTypes.bool,
  placeholderLabel: PropTypes.string,
};
PasswordInput.defaultProps = {
  disabled: false,
  pwdName: '',
  label: '',
  isGuide: false,
  placeholderLabel: '',
};
export default PasswordInput;
